export const TEST_ENVS = [
  'aurora1',
  'aurora2',
  'nebula1',
  'libra1',
  'apollo1',
  'nova1',
  'data1',
  'taurus1',
  'taurus2',
  'phoenix1',
  'phoenix2',
  'seal1',
  'polaris1',
  'polaris2',
  'ai1',
] as const;
